import {
    defaultMarketResearchState,
} from "@relode/core";
import produce from "immer";

import {
    ClientPublicJobActionTypes,
    names,
} from "./clientPublicJobActionTypes";
import { ClientPublicJobState } from "./clientPublicJobState";

export const clientPublicJobReducer = (
    state: ClientPublicJobState,
    action: ClientPublicJobActionTypes
) =>
    produce(state, draft => {
        switch (action.type) {
            case names.LOAD_JOB: {
                draft.ui.fetchState = "loading";
                draft.data.marketResearch = defaultMarketResearchState;
                break;
            }

            case names.LOAD_JOB_SUCCESS: {
                draft.ui.fetchState = "success";
                draft.data.job = action.payload.job;
                draft.data.currentJobId = action.payload.job.details.jobId;
                draft.data.token = action.payload.token;
                draft.ui.error = undefined;
                break;
            }

            case names.LOAD_JOB_FAILURE: {
                draft.ui.fetchState = "error";
                draft.ui.error = action.payload.error;
                draft.data.currentJobId = undefined;
                draft.data.job = undefined;
                break;
            }

            case names.MARKET_RESEARCH_COMPENSATION: {
                draft.data.marketResearch.compensation = {
                    isBusy: true,
                };
                break;
            }

            case names.MARKET_RESEARCH_COMPENSATION_SUCCESS: {
                draft.data.marketResearch.compensation = {
                    isBusy: false,
                    error: undefined,
                    data: action.payload.data,
                };
                break;
            }

            case names.MARKET_RESEARCH_COMPENSATION_FAILURE: {
                draft.data.marketResearch.compensation = {
                    isBusy: false,
                    data: undefined,
                    error: action.payload.error,
                };
                break;
            }

            case names.MARKET_RESEARCH_SUPPLY_DEMAND: {
                draft.data.marketResearch.supplyDemand = {
                    isBusy: true,
                };
                break;
            }

            case names.MARKET_RESEARCH_SUPPLY_DEMAND_SUCCESS: {
                draft.data.marketResearch.supplyDemand = {
                    data: action.payload.data,
                    isBusy: false,
                    error: undefined,
                };
                break;
            }

            case names.MARKET_RESEARCH_SUPPLY_DEMAND_FAILURE: {
                draft.data.marketResearch.supplyDemand = {
                    error: action.payload.error,
                    isBusy: false,
                    data: undefined,
                };
                break;
            }

            case names.MARKET_RESEARCH_DIVERSITY: {
                draft.data.marketResearch.diversity = {
                    isBusy: true,
                };
                break;
            }

            case names.MARKET_RESEARCH_DIVERSITY_SUCCESS: {
                draft.data.marketResearch.diversity = {
                    isBusy: false,
                    data: action.payload.data,
                };
                break;
            }

            case names.MARKET_RESEARCH_DIVERSITY_FAILURE: {
                draft.data.marketResearch.diversity = {
                    isBusy: false,
                    data: undefined,
                    error: action.payload.error,
                };
                break;
            }

            case names.MARKET_RESEARCH_SUMMARY: {
                draft.data.marketResearch.summary = {
                    isBusy: true,
                    data: undefined,
                    error: undefined,
                };
                break;
            }

            case names.MARKET_RESEARCH_SUMMARY_SUCCESS: {
                draft.data.marketResearch.summary = {
                    isBusy: false,
                    data: action.payload.summary,
                    error: undefined,
                };
                break;
            }

            case names.MARKET_RESEARCH_SUMMARY_FAILURE: {
                draft.data.marketResearch.summary = {
                    isBusy: false,
                    data: undefined,
                    error: action.payload.error,
                };
                break;
            }

            default: {
                return state;
            }
        }
    });
